import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/context/AuthContext';
import { Analytics } from '@vercel/analytics/react';
import LandingPage from '@/pages/LandingPage';
import SubmitStoryPage from '@/pages/SubmitStoryPage';
import StoryViewPage from '@/pages/StoryViewPage';
import EditStoryPage from '@/pages/EditStoryPage';
import ReviewStoryPage from '@/pages/ReviewStoryPage';
import LearnPage from '@/pages/LearnPage';
import AboutPage from '@/pages/AboutPage';
import MyStoriesPage from '@/pages/MyStoriesPage';
import ProfilePage from '@/pages/ProfilePage';
import ModerationDashboard from '@/pages/ModerationDashboard';
import SearchResultsPage from '@/pages/SearchResultsPage';
import BrowseStoriesPage from '@/pages/BrowseStoriesPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/submit" element={<SubmitStoryPage />} />
            <Route path="/my-stories" element={<MyStoriesPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/story/:id/edit" element={<EditStoryPage />} />
            <Route path="/story/:id/review" element={<ReviewStoryPage />} />
            <Route path="/story/:id" element={<StoryViewPage />} />
            <Route path="/moderation" element={<ModerationDashboard />} />
            <Route path="/search" element={<SearchResultsPage />} />
            <Route path="/browse" element={<BrowseStoriesPage />} />
            <Route path="/learn" element={<LearnPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        <Analytics />
      </div>
    </AuthProvider>
  );
}

export default App;